import React from 'react';
import loadable from '@wix/yoshi-flow-editor/loadable';
import type { NormalizedPost } from '../../../common/types';

const PostPageWixCommentsUnsafe = loadable(
  () => import(/* webpackChunkName: "post-page-wix-comments" */ './post-page-wix-comments'),
);

/** @deprecated Remove when merging OOI_EXPERIMENTS.USE_NEW_POST_PAGE_SETTINGS_URL */
export const PostPageWixCommentsSeo: React.FC<{ post: NormalizedPost }> = (props) => {
  return <PostPageWixCommentsUnsafe {...props} />;
};
